import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twMerge } from "tailwind-merge";

interface SpinnerProps {
    visible: boolean;
}

export const Spinner = ({ visible = true }: SpinnerProps) => {
    return <div className={twMerge(visible ? 'visible' : 'invisible')}><FontAwesomeIcon icon={faSpinner} spin /></div>
}